module.exports = __webpack_public_path__ + "media/components/country-flag/static/in-fd8e911182680a39719929a06ae8658b.svg";